import mapValues from 'lodash/mapValues';

import { BreakPointsMap, VALID_BREAKPOINTS } from '../../../../../lib/StyledComponents/StyledComponents';

export const VALID_MEDIA_QUERY_INPUTS: { [key in VALID_BREAKPOINTS]: string } =
  mapValues(BreakPointsMap, (val, _) => `(min-width:${val}em)`);
